<script>
  import { onMount } from 'svelte';

  export let isDynamic = false;
  export let cpBase = 'https://mobileapi.usebutton.com/cp';

  const { hostname } = window.location;
  const baseUrl = hostname.includes('-staging')
    ? cpBase.replace('mobileapi', 'mobileapi-staging')
    : cpBase;

  const currentUrl = encodeURIComponent(window.location.href);

  onMount(() => {
    new Image().src = `${baseUrl}?event=view&url=${currentUrl}&dynamic=${isDynamic}&ts=${Date.now()}`;
  });

  function trackClick(event) {
    const clickedUrl = encodeURIComponent(event.currentTarget.href);
    new Image().src = `${baseUrl}?event=click&url=${currentUrl}&action=${clickedUrl}&ts=${Date.now()}`;
  }
</script>

<svelte:window
  on:click={(e) => {
    const target = e.target.closest('a');
    if (target && target.href) {
      e.preventDefault();
      trackClick({ currentTarget: target });
      setTimeout(() => {
        window.open(target.href, '_blank');
      }, 100);
    }
  }}
/>
